import type { CvssSeverity } from './cvss-types';

export const SEVERITY_COLORS: Record<CvssSeverity, string> = {
  Critical: '#dc2626',
  High: '#ea580c',
  Medium: '#d97706',
  Low: '#65a30d',
  Info: '#6b7280',
};

export const CVSS_SCORE_COLORS = {
  none: '#9ca3af',
  low: '#65a30d',
  medium: '#d97706',
  high: '#ea580c',
  critical: '#dc2626',
} as const;

export function getSeverityFromScore(score: number): CvssSeverity {
  if (score >= 9.0) return 'Critical';
  if (score >= 7.0) return 'High';
  if (score >= 4.0) return 'Medium';
  if (score >= 0.1) return 'Low';

  return 'Info';
}

export function getColorFromScore(score: number): string {
  if (score === 0) return CVSS_SCORE_COLORS.none;
  if (score < 4) return CVSS_SCORE_COLORS.low;
  if (score < 7) return CVSS_SCORE_COLORS.medium;
  if (score < 9) return CVSS_SCORE_COLORS.high;

  return CVSS_SCORE_COLORS.critical;
}

export function getSeverityColor(severity: CvssSeverity): string {
  return SEVERITY_COLORS[severity];
}

export const CVSS_SEVERITIES = [
  'Critical',
  'High',
  'Medium',
  'Low',
  'Info',
] as const satisfies readonly CvssSeverity[];

export const CVSS_SEVERITY_BAND_LABELS: Record<CvssSeverity, string> = {
  Critical: '9.0 through 10.0',
  High: '7.0 through 8.9',
  Medium: '4.0 through 6.9',
  Low: '0.1 through 3.9',
  Info: 'below 0.1',
};
